import React, { useState } from 'react'
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  TableContainer,
  Grid,
  Dialog,
  DialogTitle,
  Typography
} from '@mui/material'
import MyButton from '../../ui/MyButton'
import formatMoney from '../../../utils/formatMoney'
import { useFormikContext } from 'formik'
import styled from '@emotion/styled'

const CellHead = styled(TableCell)({
  fontWeight: 600,
  fontSize: '17px'
})

const LessonList = ({ lessons, nextPage }) => {
  const [openTypeOfLessonContentDialog, setOpenTypeOfLessonContentDialog] = useState(false)
  const [dialogContent, setDialogContent] = useState('')
  const { setFieldValue } = useFormikContext()

  const handleClick = (lessonId) => {
    setFieldValue('lesson', lessonId)
    nextPage()
  }

  const getMinPeriodPrice = (periods) => {
    const periodsValuesArray = Object.values(periods)
    const priceArray = periodsValuesArray.map((item) => item.price)
    const filteredUndefinedArray = priceArray.filter(
      (item) => item !== undefined && item !== 0
    )
    return Math.min(...filteredUndefinedArray)
  }

  const handleOpenContentDialog = (content) => {
    setDialogContent(content)
    setOpenTypeOfLessonContentDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenTypeOfLessonContentDialog(false)
  }

  return (
    <TableContainer
      component={Paper}
      style={{
        background: '#fff',
        padding: '1em'
      }}
    >
      <Table>
        <TableHead>
          <TableRow>
            <CellHead>Tên kiểu bài học</CellHead>
            <CellHead>Giá thấp nhất từ</CellHead>
            <TableCell align="right">&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lessons &&
            lessons.map((lesson) => {
              return (
                <TableRow key={lesson._id}>
                  <TableCell>
                    {lesson.lessonName}
                  </TableCell>
                  <TableCell align="right">
                    {formatMoney(getMinPeriodPrice(lesson.periods[0]))}&nbsp;VNĐ
                  </TableCell>
                  <TableCell aign="right">
                    <Grid container justifyContent='center' align='center' spacing={1}>
                      <Grid item>
                        <MyButton
                          onClick={() => {
                            handleClick(lesson._id)
                          }}
                        >
                          Chọn
                        </MyButton>
                      </Grid>

                      <Grid item>
                        <MyButton
                          onClick={() => {
                            handleOpenContentDialog(lesson.content)
                          }}
                        >
                          Xem thêm
                        </MyButton>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>

      <Dialog onClose={handleCloseDialog} open={openTypeOfLessonContentDialog}>
        <DialogTitle style={{ textAlign: 'center' }}>Nội dung bài học</DialogTitle>
        <Typography style={{ padding: '0 2em 2em 2em' }} variant='body1'>{dialogContent}</Typography>
        <div style={{ paddingBottom: '1.5em', textAlign: 'center' }}>
          <MyButton onClick={handleCloseDialog}>Đóng</MyButton>
        </div>
      </Dialog>
    </TableContainer>
  );
}

export default LessonList
